import fm1 from '../../assets/Events/Firstmeet1.jpg'
import fm2 from '../../assets/Events/Firstmeet4.jpg'
import fm3 from '../../assets/Events/Firstmeet5.jpg'
import fm4 from '../../assets/Events/Firstmeet6.jpg'


export const firstMeet = [
    {
        name: 'First Meet',
        img: fm1
    },
    {
        name: 'First Meet',
        img: fm2
    },
    {
        name: 'First Meet',
        img: fm3
    },
    {
        name: 'First Meet',
        img: fm4
    },
    
]